import { FC } from 'react';

import { useSelector } from 'react-redux'
import * as Yup from 'yup';

import { Formulario } from 'view/component/Formulario/Formulario';
import { SolicitacaoDetalhada } from 'model/solicitacao/SolicitacaoDetalhada';
import { SolicitacaoCorrenteSelector } from 'store/SolicitacaoCorrente/SolicitacaoCorrente.selector';
import { FilePondFile } from 'filepond';
import { validadorAnexos } from 'business/validacao/AnexosValidacao';
import { RestricoesSolicitacaoServicoFormulario } from 'business/formulario/RestricoesSolicitacaoServicoFormulario';
import { useRestricoesFormulario } from 'service/restricao/useRestricoesFormulario/useRestricoesFormulario';



const SolicitacaoServicoSchema = Yup.object().shape({
  titulo: Yup.string().required().label("Título"),
  descricao: Yup.string().required().label("Descrição"),
  classificacao: Yup.string().required().label("Classificação"),
  // Solicitante é opcional: Se o solicitante não for definido, o chamado é aberto como se o solicitante
  // fosse quem abriu o chamado
  // idSolicitante: Yup.string().required().label("Solicitante"),
});

const validador = (formulario: any) => {
  const erros: {[key: string]: {[key: string]: string}} = { };
  const anexos: FilePondFile[] = formulario.extra?.anexos ?? [];

  return {
    ...erros,
    ...validadorAnexos("extra.anexos", anexos)
  }
}

interface SolicitacaoServicoPageFormularioProps {
  solicitacao: SolicitacaoDetalhada;
  onSubmit: (values: any) => void | Promise<any>;
}

export const SolicitacaoServicoPageFormulario: FC<SolicitacaoServicoPageFormularioProps> = ({solicitacao, onSubmit, children}) => {
  const carregando = useSelector(SolicitacaoCorrenteSelector.formulario.isCarregando);
  const operacao = useSelector(SolicitacaoCorrenteSelector.formulario.operacao);
 
  const restricoes = useRestricoesFormulario(RestricoesSolicitacaoServicoFormulario);

  return <Formulario
    formik={{
      enableReinitialize: true,
      initialValues: solicitacao,
      validationSchema: SolicitacaoServicoSchema,
      validate: validador,
      onSubmit: onSubmit
    }}

    carregando={carregando}
    operacao={operacao}
    restricoes={restricoes}
    className="solicitacao-servico-page"
    >
    {children}
  </Formulario>
}